import React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { Nav, NavDropdown, MenuItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import MobileNavLink from './mobile_nav_link';
import { Sidebar } from '../Sidebar/';
import i18next from "i18next";
import * as actions from '../../actions/grouping_actions';
import QuickLinksService from '../../services/quick_links_service';

@connect(state => {
  return {
    authenticated: state.auth.authenticated
  }
}, actions)
class Header extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      mobileNavIsOpened: false,
      hoveredLink: null
    };
    this.showMobileNav = this.showMobileNav.bind(this);
  }

  renderLinks(availableRoutes) {
    if (this.props.authenticated) {
      if (availableRoutes) {
        return availableRoutes.map((menuItem, i) => {
          if (menuItem.showOnMenu) {
            if (menuItem.icon === 'op-icon-quicklinks') {
              return (
                <QuickLinksDropdown
                  key={menuItem.id}
                  icon={menuItem.icon}
                  linkHovered={this.linkHovered.bind(this)}
                />
              );
            }
            return (
                <HeaderLink
                    key={menuItem.id}
                    to={menuItem.path}
                    linktext={menuItem.title}
                    icon={menuItem.icon}
                    currentLinkHovered={this.state.hoveredLink}
                    linkHovered={this.linkHovered.bind(this)}
                  />
            );
          } else {
            return null;
          }
        });
      } else {
        return null;
      }
    } else {
      return [ ];
    }
  }

  renderMobileNavLinks(availableRoutes) {
    let allNavLinks = [];
    if (this.props.authenticated) {
      if (availableRoutes) {
        return availableRoutes.map((menuItem, i) => {
          if (menuItem.showOnMenu) {
            allNavLinks = [];
            allNavLinks.push(<HeaderMobileLink key={menuItem.id} to={menuItem.path} dataCategory={menuItem.title} linkText={ i18next.t(`menus.from-router.${menuItem.title}`) } showMobileNav = { this.showMobileNav } />);
            allNavLinks.push(menuItem.children.map((subNavItem, i) => {
              if (subNavItem.showOnMenu) {
                return <HeaderMobileLink subNavItemClass="secondary" dataCategory={menuItem.title} key={subNavItem.id} to={subNavItem.path} linkText={ i18next.t(`menus.from-router.${subNavItem.title}`) } showMobileNav = { this.showMobileNav } />
              }
            }));
            return allNavLinks.map((navLink) => {
              return navLink;
            });
          } else {
            return null;
          }
        });
      } else {
        return null;
      }
    } else {
      return [ ];
    }
  }

  showMobileNav(e) {
    // check if mobile nav menu is currently displayed
    const { mobileNavIsOpened } = this.state;

    // clicking the menu toggle button or selecting a subnav link should toggle the menu open/closed
    if (e.target.parentNode.parentNode.className === 'secondary' ||
        e.target.parentNode.parentNode.className === 'top-nav__right-controls-container') {
      this.setState({
        // toggle value of `opened`
        mobileNavIsOpened: !mobileNavIsOpened,
      });
    } else {
      // clicking a "menu category" should accordion that category's subnav links
      e.preventDefault();

      const primaryListItems = Array.from(e.target.closest('ul').querySelectorAll('.primary'));

      primaryListItems.map(listItem => {
        listItem.classList.remove('open');

        if (e.target.getAttribute('data-category') === listItem.querySelector('a').getAttribute('data-category')) {
          listItem.classList.add('open');
        }
      });

      const secondaryLinks = Array.from(e.target.closest('ul').querySelectorAll('.secondary a'));

      secondaryLinks.map(link => {
        const listItem = link.closest('li');

        if (e.target.getAttribute('data-category') === link.getAttribute('data-category')) {
          listItem.classList.remove('collapsed');
        } else {
          listItem.closest('li').classList.add('collapsed');
        }
      });
    }
  }

  linkHovered(hoveredLink) {
    if (this.state.hoveredLink != hoveredLink) {
      this.setState({ hoveredLink: hoveredLink });
    }
  }

  render() {
    let availableRoutes = this.props.availableRoutes.filter((availableRoute) => availableRoute.children && availableRoute.children.filter((childRoute) => childRoute.showOnMenu).length);

    return (
      <div onMouseLeave={() => this.linkHovered(null)} className="header-wrapper">
        <nav className="top-nav">

          <div id="navbar" className="top-nav__nav-bar">
            <ul>
              {this.renderLinks(availableRoutes)}
            </ul>
          </div>
          <div className="top-nav__right-controls-container">
            <div className="top-nav__mobile-menu-toggle">
              <button className={`top-nav__mobile-nav-button${ this.state.mobileNavIsOpened ? ' open':'' }`} onClick={ this.showMobileNav } />
            </div>

            <div className="top-nav__user-icon">
              <Nav activeKey="1">
                <NavDropdown title="" eventKey="4" id="nav-dropdown" className="op-menu-icon op-icon-user" noCaret={true}>
                  <LinkContainer to="/help">
                    <MenuItem eventKey="4.1">{ i18next.t('menus.help') }</MenuItem>
                  </LinkContainer>
                  <LinkContainer to="/user/profile">
                    <MenuItem eventKey="4.2">{ i18next.t('menus.profile') }</MenuItem>
                  </LinkContainer>
                  <LinkContainer to="/signout">
                    <MenuItem eventKey="4.3">{ i18next.t('menus.log-out') }</MenuItem>
                  </LinkContainer>
                </NavDropdown>
              </Nav>
            </div>
          </div>
          { this.state.mobileNavIsOpened && (
              <div className="top-nav__mobile-menu">
                <ul>
                  {this.renderMobileNavLinks(availableRoutes)}
                </ul>
              </div>
          ) }

          <Sidebar availableRoutes={availableRoutes} hoveredLink={this.state.hoveredLink}/>

        </nav>
      </div>
    );
  }
}

const QuickLinksChevron = () => (
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: '6px', verticalAlign: 'middle' }}>
    <path d="M4.33984 5.04883L0.214844 0.923828C0 0.730469 0 0.408203 0.214844 0.193359C0.408203 0 0.730469 0 0.945312 0.193359L4.70508 3.97461L8.46484 0.214844C8.6582 0 8.98047 0 9.19531 0.214844C9.38867 0.408203 9.38867 0.730469 9.19531 0.923828L5.04883 5.04883C4.85547 5.26367 4.5332 5.26367 4.33984 5.04883Z" fill="#2F6D85"/>
  </svg>
);

const iconStyle = { width: '16px', display: 'inline-block', textAlign: 'center', marginRight: '8px', verticalAlign: 'middle', flexShrink: 0 };

const WrenchIcon = () => (
  <span style={iconStyle}>
    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"/>
    </svg>
  </span>
);

const ExternalLinkIcon = () => (
  <span style={iconStyle}>
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
      <polyline points="15 3 21 3 21 9"/>
      <line x1="10" y1="14" x2="21" y2="3"/>
    </svg>
  </span>
);

class QuickLinksDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { links: [] };
    this.fetchLinks = this.fetchLinks.bind(this);
  }

  fetchLinks() {
    QuickLinksService.getAll().then(response => {
      this.setState({ links: response.quickLinks });
    }).catch(err => {
      console.error('Failed to load quick links', err);
    });
  }

  componentDidMount() {
    this.fetchLinks();
  }

  render() {
    const { icon, linkHovered } = this.props;
    const { links } = this.state;
    const title = <span>{i18next.t('menus.from-router.Quick Links')}<QuickLinksChevron /></span>;
    return (
      <NavDropdown
        title={title}
        eventKey="5"
        id="quick-links-dropdown"
        className={`op-menu-icon ${icon}`}
        noCaret={true}
        onMouseEnter={() => linkHovered && linkHovered('quicklinks')}
        onToggle={(isOpen) => { if (isOpen) this.fetchLinks(); }}
      >
        {links.map((link, i) => (
          <MenuItem key={link.id} eventKey={`5.${i + 1}`} href={link.url} target="_blank" rel="noopener noreferrer" title={link.url}>
            <ExternalLinkIcon />{link.title}
          </MenuItem>
        ))}
        {links.length > 0 && <MenuItem divider />}
        <LinkContainer to="/admin-admin/quick-links">
          <MenuItem eventKey="5.configure" className="quick-links-configure">
            <WrenchIcon />Configure Quick Links
          </MenuItem>
        </LinkContainer>
      </NavDropdown>
    );
  }
}

class HeaderLink extends React.Component {

  constructor(props) {
    super(props);

    let place = this.props.to;
    let text = i18next.t(`menus.from-router.${this.props.linktext}`);
    let className = "op-menu-icon";
    if (this.props.icon) {
      className += " " + this.props.icon;
    }

    this.state = {
      className: className,
      link: <NavLink
              to={place}
              onMouseEnter={() => props.linkHovered(place)}
              >{ text }</NavLink>,
      location:null
    };
  }

  componentDidMount() {
    this.stopHistoryListener = this.props.history.listen((location, action) => {
      this.setState({
        className: this.state.className,
        link: this.state.link,
        location: location
      });
    });
  }

  componentWillUnmount() {
    this.stopHistoryListener();
  }

  render() {
    let className = this.state.className;
    let { location } = this.props;

    if (this.state.location) {
      location = this.state.location;
    }

    if (!this.state.link) {
      return (<h1>{ i18next.t('loading') }</h1>);
    } else {
      if (this.props.currentLinkHovered) {
        if (this.props.currentLinkHovered.startsWith(this.state.link.props.to)) {
          className += " active";
        }
      } else {
        if (location.pathname.startsWith(this.state.link.props.to)) {
          className += " active";
        }
      }

      return (
          <li className={className}>
            {this.state.link}
          </li>
      );
    }
  }
}

class HeaderMobileLink extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      place: this.props.to,
      linkText: this.props.linkText,
      subNavItemClass: this.props.subNavItemClass,
      location: null,
      showMobileNav: this.props.showMobileNav,
      dataCategory: this.props.dataCategory
    };
  }

  componentDidMount() {
    this.stopHistoryListener = this.props.history.listen((location, action) => {
      this.setState({
        link: this.state.link
      });
    });
  }

  componentWillUnmount() {
    this.stopHistoryListener();
  }

  render() {
    let { location } = this.props.history;

    if (!this.state.place) {
      return (<h1>{ i18next.t('loading') }</h1>);
    } else {
      let categoryPathEnd = this.state.place.indexOf('/', 1);
      const categoryPath = this.state.place.substring( 0, (categoryPathEnd === -1 ? this.state.place.length : categoryPathEnd));

      if (location.pathname.startsWith(categoryPath)) {
        this.state.spanClassName = "active-category";
      }

      if (location.pathname.match(this.state.place) && this.state.subNavItemClass) {
        this.state.spanClassName += " active";
      }

      return (
          <MobileNavLink linkProperties={ this.state } showMobileNav = { this.props.showMobileNav } />
      );
    }
  }
}

HeaderLink = withRouter(HeaderLink);
HeaderMobileLink = withRouter(HeaderMobileLink);

export default withRouter(Header);
